var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stream-ended-container"},[_c('SdsIllustration',{attrs:{"illustrationName":"video"}}),_c('p',[_vm._v("Event has ended.")]),_c('p',[_vm._v("Closing stream in "+_vm._s(_vm.timer)+"s")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }